<template>
  <div class="p-2 flex flex-row justify-center h-full text-gray-200">
    <div class="text-sm flex flex-col">
      <div
        class="w-8 h-8 border border-gray-600 rounded-full flex justify-center items-center mt-2"
        :class="isSync ? 'bg-teal-600 text-white' : ''"
        @click="sync()"
      >
        <UploadCloudIcon size="16" :class="isSync ? 'anim' :''" />
      </div>
      <div class="border border-gray-600 mt-3"></div>
      <div class="tool-button relative flex items-center">
        <!-- <MaximizeIcon stroke-width="1" class="m-auto" /> -->
        <p
          class="p-1 text-center"
          @click="selectTool({tool:'rect',value:selectedTag})"
        >{{selectedTag}}</p>
        <div
          ref="chev"
          class="w-1 relative outline-none"
          tabindex="-1"
          @click="onFocus()"
          @focus="onFocus()"
          @blur="onBlur()"
        >
          <ChevronDownIcon size="12" class="ml-2" />
          <div class="relative text-gray-700" v-if="isShowTagList">
            <div
              class="absolute top-0 bg-white p-1 rounded -mt-8 cursor-pointer"
              style="left:10px; "
            >
              <!--  -->
              <div
                v-for="(item, i) of ['DIV','H1','H2','H3','H4','H5','H6']"
                class="hover:font-bold"
                @click="_ => {selectedTag = item; isShowTagList = false }"
                :key="i"
              >{{item}}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="tool-button" @click="selectTool({tool:'lorem'})">
        <p style="font-size:8px" class>Lorem</p>
      </div>
      <div class="tool-button" @click="selectTool({tool:'image'})">
        <ImageIcon stroke-width="1" class="m-auto" />
      </div>

      <div class="tool-button" @click="selectTool({tool:'video'})">
        <VideoIcon stroke-width="1" class="m-auto" />
      </div>
      <div class="tool-button" @click="selectTool({tool:'input'})">
        <TerminalIcon stroke-width="1" class="m-auto" />
      </div>
      <div class="tool-button" @click="selectTool({tool:'button'})">
        <p>btn</p>
      </div>
      <div class="text-xs mt-5 text-center">
        <span>{{copyValue}}</span>
        <span>Copies</span>
        <vue-slider v-bind="{max:50}" @change="onCopyValue"></vue-slider>
      </div>
      <div class="flex-grow"></div>
      <div class="tool-button" @click="preview">
        <EyeIcon v-if="isPreview" class="m-auto" />
        <EyeOffIcon v-else class="m-auto" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  name: "IconBar",
  props: {
    msg: String
  },
  data() {
    return {
      selectedTag: "DIV",
      isShowTagList: false,
      copyVal: 1,
      gridTool: false,
      gridValue: { col: 1, row: 1 }
    };
  },
  mounted() {},
  computed: {
    ...mapState(["copyValue"]),
    ...mapGetters(["tools", "selectedTool", "isPreview", "isSync"])
  },
  methods: {
    ...mapActions(["selectTool", "preview", "sync", "setCopyValue"]),
    onFocus() {
      this.isShowTagList = true;
      console.log("onBlur");
      this.$refs.chev.focus();
    },
    onBlur() {
      console.log("onBlur");
      this.isShowTagList = false;
      this.$refs.chev.blur();
    },
    onCopyValue(val) {
      this.setCopyValue({ copyValue: val });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.anim {
  animation: up 2s infinite;
}
@keyframes up {
  from {
    transform: translateY(4px);
  }
  to {
    transform: translateY(-4px);
  }
}
</style>
